<script lang="ts">
  import { fade } from "../transition"
</script>

<svg
  class:direction-indicator={true}
  {...$$restProps}
  width="49"
  height="36"
  viewBox="0 0 49 36"
  fill="none"
  stroke="currentColor"
  stroke-width="3"
  stroke-linecap="round"
  xmlns="http://www.w3.org/2000/svg"
  in:fade|local={{ delay: 500, duration: 500 }}
>
  <path d="M7.99993 7.71436L18.2856 18.0001L7.99993 28.2858" />
  <path d="M18.2858 7.71436L28.5715 18.0001L18.2858 28.2858" />
  <path d="M29.7143 7.71436L40 18.0001L29.7143 28.2858" />
</svg>

<style lang="postcss">
  path {
    @apply animate-[1.2s_infinite_blink];

    &:nth-child(1) {
      animation-delay: 0s;
    }
    &:nth-child(2) {
      animation-delay: 0.15s;
    }

    &:nth-child(3) {
      animation-delay: 0.3s;
    }

    @keyframes blink {
      0%,
      100% {
        opacity: 0.1;
        animation-timing-function: ease-in;
      }
      40% {
        opacity: 1;
        animation-timing-function: ease-out;
      }
    }
  }
</style>
